import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";


/** Formats numeric input with space-separated thousands and a comma decimal. */
export const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props: any,
  ref
) {
  const { onChange, ...other }: any = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator=" "
      valueIsNumericString
      decimalSeparator=","
    />
  );
});


/** Formats numbers with European thousands and decimal separators. */
export const EuropeanNumberFormatCustom = forwardRef(function NumericFormatCustom(
  props: any,
  ref
) {
  const { onChange, ...other }: any = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      valueIsNumericString
    />
  );
});